import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {LanguageStore}                                         from '../../stores/translation/language.store';
import {MapViewStore}                                          from '../../stores/layout/mapview.store';

@Component({
  selector: 'ap-info-agreement',
  template: `
    <ap-pdf-viewer [relativePath]="url" [showDownloadButton]="true"></ap-pdf-viewer>`,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class InfoAgreementComponent {
  public url: string;

  constructor(private language: LanguageStore,
              private mapViewStore: MapViewStore) {
    const key = this.language.SelectedLanguage.Key;
    this.url = '/assets/info/agreement/de/agreement.pdf';
    if (key !== 'de') {
      this.url = '/assets/info/agreement/en/agreement.pdf';
    }
    this.mapViewStore.hideMapView();
  }
}
